import axios from 'axios';
import configs from '@/common/config';
export default {
  getStageAndTenant: async () => {
    try {
      let prefix = axios.defaults.baseURL ? '' : '/api';

      const response = await axios.get(prefix + `/configs/stage-and-tenant`, { params: { origin: window.location.origin } });
      let { data } = response;
      return data;
    } catch (err) {
      console.log('Failed loading stage and tenant settings', err);
    }
  },

  loadPreAuthUiConfig: () => {
    return axios.get(`/configs/pre-auth-ui-config?customer=${configs.customer}`);
  },

  loadAuthenticatedUiConfig: () => axios.get(`/configs/auth-ui-config`),
};
